///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageViewComponent } from './landing-page.view.component';
import { AuthenticationGuardService } from '../../../core/auth/authentication-guard.service';

const routes: Routes = [
    {
        path: 'landing',
        component: LandingPageViewComponent,
        canActivate: [AuthenticationGuardService],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [],
})
export class LandingPageRoutingModule {}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/modules/application/landing-page/landing-page-routing.module.ts